import { render, staticRenderFns } from "./RelatoriosDialog.vue?vue&type=template&id=67affd90&scoped=true"
import script from "./RelatoriosDialog.vue?vue&type=script&lang=js"
export * from "./RelatoriosDialog.vue?vue&type=script&lang=js"
import style0 from "./RelatoriosDialog.vue?vue&type=style&index=0&id=67affd90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67affd90",
  null
  
)

export default component.exports